import { render, staticRenderFns } from "./Step2Recommend.vue?vue&type=template&id=dde5686e&scoped=true&"
import script from "./Step2Recommend.vue?vue&type=script&lang=js&"
export * from "./Step2Recommend.vue?vue&type=script&lang=js&"
import style0 from "./Step2Recommend.vue?vue&type=style&index=0&id=dde5686e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde5686e",
  null
  
)

export default component.exports